'use strict';
// @flow

import * as _ from "lodash";

export function removeNullProperties(obj : any) {
  return _.pickBy(obj, (v) => v || typeof v === 'number');
}